import {Box, Flex, P} from 'exsportia-components'
import React, {FC, useCallback} from 'react'

import {PaymentMethod} from '../../../api/user/types'
import {useLocale} from '../../../utils/i18n'
import {isNilOrEmpty} from '../../../utils/logic'
import {ExsportiaIcon, exsportiaIcons} from '../exsportia-icon/exsportia-icon'

type PaymentMethodItem = {
  paymentMethod?: PaymentMethod;
  additionalCardLabel?: string;
  text?: string;
  edit?: () => void
}

const paymentSystemToIcon: {[key: string]: keyof typeof exsportiaIcons} = {
  'Visa': 'visa',
  'MasterCard': 'masterclass',
  'AmericanExpress': 'americanExpress'
}

export const PaymentMethodItem: FC<PaymentMethodItem> = ({
  paymentMethod,
  additionalCardLabel = '',
  text,
  edit
}) => {
  const {l} = useLocale()
  const icon = paymentMethod?.brand ? paymentSystemToIcon[paymentMethod.brand] : 'creditCard'
  const handleEdit = useCallback(() => edit?.(), [edit])

  return (
    <Flex
      flexDirection={'row'}
      alignItems={'center'}
      py={'12'}
      flex={1}
    >
      <Flex
        mr={'8'}
        width={40}
        height={24}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <ExsportiaIcon icon={icon}/>
      </Flex>
      <Box flex={1} alignItems={'flex-start'}>
        <P variant={'body'}>
          {
            text
            ? text
            : (
              isNilOrEmpty(paymentMethod)
                ? l('payment_method_not_selected')
                :`${additionalCardLabel} ···· ${paymentMethod.last4Digits}`
            )
          }
        </P>
      </Box>
      {
        Boolean(edit)
        && (
          <Box onClick={handleEdit}>
            <P color={'primary'}>
              {l('edit')}
            </P>
          </Box>
        )
      }
    </Flex>
  )
}